'use strict';

window.TIPOS_OUTRAS_OCORRENCIAS = ['climatica', 'manutencao_melhoria', 'solo', 'massa_seca_pastagem'];

/* eslint-disable max-lines-per-function, max-params */
angular.module('webAgro1App').controller('ResumoOcorrenciasCtrl', function($scope, $filter) {
  const SITUACAO_NEUTRO = {
    id: 0,
    descricao: 'Sem Ocorrência',
    descricaoJson: 'neutro'
  };

  const SITUACAO_EQUILIBRIO = {
    id: 1,
    descricao: 'Baixa',
    descricaoJson: 'equilibrio'
  };

  const outrasOcorrencias = function(_event, _history, markers) {
    $scope.outrasOcorrencias = markers.map(function(marker) {
      let descricao = marker.objeto.acao || (marker.objeto.evento || {}).descricao || marker.situacao || '';
      if (marker.objeto.tipo === TIPOS_OUTRAS_OCORRENCIAS[3] && !descricao) {
        descricao = `Massa seca de pastagem ${$filter('number')(marker.objeto.quantidade_massa_seca, 1)} kg/ha`;
      }

      return { descricao, marker };
    });
  };

  const ocorrencias = function(_event, _history, markers) {
    $scope.ocorrencias = markers.map(function(marker) {
      return {
        marker: marker,
        items: marker.objeto.selectedItems.map(function(item) {
          return {
            descricao: item.descricao,
            status: (item.indicadores || []).reduce(function(result, record) {
              const situacaoRecord = (record || {}).situacao || { id: -1 };
              return result.id > situacaoRecord.id ? result : situacaoRecord;
            }, item.temOcorrencias ? SITUACAO_EQUILIBRIO : SITUACAO_NEUTRO)
          };
        })
      };
    });
  };

  $scope.$on('invasora', ocorrencias);
  $scope.$on('inseto', ocorrencias);
  $scope.$on('doenca', ocorrencias);
  $scope.$on('nematoide', ocorrencias);
  $scope.$on('inimigo_natural', ocorrencias);

  $scope.$on('climatica', outrasOcorrencias);
  $scope.$on('manutencao_melhoria', outrasOcorrencias);
  $scope.$on('solo', outrasOcorrencias);

  $scope.setAnimationMarker = function(marker, index) {
    if (!marker.isOpen) {
      marker.setAnimation(google.maps.Animation.BOUNCE);
      $scope.$emit('startAnimatingMarker', index);
    }
  };

  $scope.resetAnimationMarker = function(marker, index) {
    marker.setAnimation(null);
    $scope.$emit('stopAnimatingMarker', index);
  };

  $scope.openInfoWindow = function(marker, index) {
    $scope.resetAnimationMarker(marker);
    google.maps.event.trigger(marker, 'click');
    $scope.$emit('openMarkerPopup', index);
  };

  const reset = function() {
    delete $scope.ocorrencias;
    delete $scope.outrasOcorrencias;
  };

  $scope.$on('invasora_close', reset);
  $scope.$on('inseto_close', reset);
  $scope.$on('doenca_close', reset);
  $scope.$on('nematoide_close', reset);
  $scope.$on('inimigo_natural_close', reset);

  $scope.$on('climatica_close', reset);
  $scope.$on('manutencao_melhoria_close', reset);
  $scope.$on('solo_close', reset);

  $scope.$on('reset', reset);

  $scope.$watch('tipo', function() {
    if ($scope.tipo !== null) {
      if (TIPOS_OPERACAO_OCORRENCIAS.includes($scope.tipo)) {
        delete $scope.outrasOcorrencias;
        return ocorrencias(null, null, $scope.data);
      }
      if (TIPOS_OUTRAS_OCORRENCIAS.includes($scope.tipo)) {
        delete $scope.ocorrencias;
        return outrasOcorrencias(null, null, $scope.data);
      }
      reset();
    }
  });
});
